import React from 'react';
import cbr1 from '../../images/project/cbr1.PNG'
import cbr2 from '../../images/project/cbr2.PNG'
import cbr3 from '../../images/project/cbr3.PNG'


const project1 = () => {
    return (
        <div>
            <div>
                <h2 className="mt-4 mb-2"> Project Details</h2>
                <p class="card-text mt-4 mb-4">● Authentication system added (user & admin) <br />
                    ● Users can order bikes, write reviews <br />
                    ● HTML, CSS, Bootstrap were used for this site</p>
            </div>
            <div>
                <div>
                    <h2 className="mt-4 mb-3">Project Screenshots</h2>
                </div>
                <div className="row" >
                    <div class="card-group">
                        <div class="card">
                            <img src={cbr1} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">HOME PAGE SECTION</h5>

                            </div>

                        </div>
                        <div class="card">
                            <img src={cbr2} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">BIKES PAGE SECTION</h5>

                            </div>

                        </div>
                        <div class="card">
                            <img src={cbr3} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">CLIENT PAGE SECTION</h5>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div >

                <button type="button" class="btn m-2 btn-success"><a className="text-white" target="_blank" style={{ textDecoration: 'none' }} href="https://my-honda-cbr-bootstrap-site.netlify.app/" >Live Site</a>
                </button>
                <button type="button" class="btn m-2 btn-danger"><a className="text-white" target="_blank" style={{ textDecoration: 'none' }} href="https://github.com/ahadakash/honda-cbr-website" >Github Code</a>
                </button>


            </div>
        </div>
    );
};

export default project1;